var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.35 83.12L109.6 61.87L89.04 41.31",
    stroke: "#EE7526",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.81 83.12L12.26 62.56L33.51 41.31",
    stroke: "#EE7526",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.21 120.42C93.9108 120.42 120.42 93.9108 120.42 61.21C120.42 28.5092 93.9108 2 61.21 2C28.5092 2 2 28.5092 2 61.21C2 93.9108 28.5092 120.42 61.21 120.42Z",
    stroke: "#EE7526",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.58 43.72C61.11 26.95 74.34 27.72 74.34 27.16C83.56 23.38 81.23 5.90002 81.23 5.90002",
    stroke: "#EE7526",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.92 55.48C73.7 52.22 73.2 48.76 70.86 46.53C69.2399 45.1283 67.2372 44.2437 65.11 43.99C62.347 43.4516 59.4909 43.6517 56.83 44.57C55.2978 45.1372 53.9122 46.0407 52.7752 47.2141C51.6382 48.3874 50.7787 49.8007 50.26 51.35C49.2148 55.1224 48.8125 59.044 49.07 62.95C49.07 63.81 49.12 64.67 49.15 65.54C49.1137 68.4348 49.4328 71.323 50.1 74.14C50.7904 76.9825 52.5534 79.4478 55.02 81.02C57.3847 82.158 60.0216 82.6085 62.63 82.32C64.4847 82.3218 66.3151 81.8976 67.98 81.08C70.5 79.67 71.91 76.88 72.74 74.08C74.47 68.31 74.31 62.16 73.96 56.14C73.95 55.95 73.94 55.72 73.92 55.48ZM63.32 55.98L60.66 56.07V48.23H63.32V55.98Z",
    stroke: "#EE7526",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.43,
    height: 122.43,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDev);
export default __webpack_public_path__ + "static/media/dev.8b24bbe6834533a518ef250850ebc88a.svg";
export { ForwardRef as ReactComponent };